import { 
  ContractType, 
  ExpensesUnit, 
  Unit, 
  ProjectStatus,
  PropertyTaxType, 
} from '~/constants';
import { Project } from '~/types/project';

const pricingEstimateDefaultValues: Partial<Project> = {
  budgetCosts: {
    INTERCONNECTION: {amount: 0, unit: Unit.WDC},
    OTHER_ITC: {amount: 0, unit: Unit.WDC},
    OTHER_NON_ITC: {amount: 0, unit: Unit.WDC},
  },
  epcCostUnit: Unit.WDC,
  contractType: ContractType.PPA,
  siteLeaseCostUnit: ExpensesUnit.KWDC,
  propertyTaxType: PropertyTaxType.EXEMPT,
  propertyTaxUnit: ExpensesUnit.YEAR,
  omPriceUnit: ExpensesUnit.KWDC,
  omProposeFlag: false,
  siteLeaseExtensions: 0,
  upfrontIncentives: 0,
  upfrontIncentiveUnit: Unit.TOTAL,
  stateSpecificUpfrontIncentiveUnit: Unit.WDC,
  installerAcknowledgmentFlag: false,
  additionalOperatingExpenses: [],
  additionalRevenues: [],
  projectArrays: [],
  preferredInvestors: [],
  status: ProjectStatus.MARKET_QUOTE,
};

export default pricingEstimateDefaultValues;